"use client";
import * as React from "react";
const SvgNotificationsSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 13 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.5 15.84a1.63 1.63 0 0 0 1.63-1.62H4.87c0 .9.73 1.62 1.63 1.62m4.88-4.87V6.9c0-2.5-1.34-4.59-3.66-5.14V0H5.28v1.77c-2.33.55-3.66 2.63-3.66 5.14v4.06L0 12.59v.82h13v-.82z" }));
export {
  SvgNotificationsSharp as default
};
